import { useState, useEffect } from 'react';
import { Container, Grid, TextField } from '@mui/material';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import PhoneNumberForm from './ChangePhoneNumber';
import ChangeEmail from './ChangeEmail';
import ChangeName from './ChangeName';
import { firestore } from '@tabletuck/firebase-services';
import { environment } from '../../../environments/environment';
import { useSelector } from 'react-redux';
import { auth } from '../../../../../../libs/firebase-service/src';
import { useTranslation } from 'react-i18next';

const PersonalInfo = () => {
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [openNameDialog, setOpenNameDialog] = useState(false);
  const [editingField, setEditingField] = useState(null); // 'firstName', 'lastName', or null

  const [openPhoneDialog, setOpenPhoneDialog] = useState(false);
  // const [user, setUser] = useState();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const user = useSelector((state) => state.authReducer.userData);
  const authState = useSelector((state) => state.authReducer);
  const [phoneNumber, setPhoneNumber] = useState(''); // Replace with your actual phone number

  const formatPhoneNumber = (number) => {
    //    +962 666666666
    if (
      environment.restaurantId === 'ttJordanDev' ||
      environment.restaurantId === 'ttJordan'
    ) {
      const digitsOnly = number?.replace(/\D/g, '');
      const countryCode = digitsOnly?.slice(3, 6);
      const areaCode = digitsOnly?.slice(6, 9);
      const subscriberNumber = digitsOnly?.slice(9);
      return `(${countryCode}) ${areaCode}-${subscriberNumber}`;
    } else {
      const digitsOnly = number?.replace(/\D/g, '');
      const countryCode = digitsOnly?.slice(1, 4);
      const areaCode = digitsOnly?.slice(4, 7);
      const subscriberNumber = digitsOnly?.slice(7);
      return `(${countryCode}) ${areaCode}-${subscriberNumber}`;
    }
  };
  let formattedPhoneNumber = formatPhoneNumber(user?.phoneNumber);
  const [t, i18n] = useTranslation();

  // Add loading state when user is not available
  if (!user) {
    return (
      <Container
        maxWidth="lg"
        style={{ marginTop: '30px', marginBottom: '30px' }}
      >
        <Typography>Loading user information...</Typography>
      </Container>
    );
  }

  // Check if we're in FattyPatty environment
  if (
    environment?.restaurantId === 'fattyPattyDev' ||
    environment?.restaurantId === 'fattyPatty'
  ) {
    return (
      <Container
        maxWidth="lg"
        style={{ marginTop: '30px', marginBottom: '30px' }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: '100%',
          }}
        >
          {/* First Name and Last Name Row */}
          <Grid container spacing={2} sx={{ marginBottom: '24px' }}>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{
                  fontWeight: 'bold',
                  marginBottom: '8px',
                  fontSize: '16px',
                  fontFamily: 'Jost, sans-serif',
                  color: '#333',
                }}
              >
                First Name
              </Typography>
              <TextField
                fullWidth
                value={user?.firstName || ''}
                variant="outlined"
                onClick={() => {
                  setEditingField('firstName');
                  setOpenNameDialog(true);
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F9F9F9',
                    borderRadius: '14px',
                    height: '52px',
                    cursor: 'pointer',
                    fontFamily: 'Jost, sans-serif',
                    '& fieldset': {
                      borderColor: 'rgba(121,121,121,0.3)',
                    },
                    '&:hover fieldset': {
                      borderColor: 'rgba(121,121,121,0.5)',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: environment.mainColor,
                    },
                  },
                  '& .MuiInputBase-input': {
                    cursor: 'pointer',
                    fontFamily: 'Jost, sans-serif',
                  },
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <EditIcon style={{ color: environment.mainColor }} />
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{
                  fontWeight: 'bold',
                  marginBottom: '8px',
                  fontSize: '16px',
                  fontFamily: 'Jost, sans-serif',
                  color: '#333',
                }}
              >
                Last Name
              </Typography>
              <TextField
                fullWidth
                value={user?.lastName || ''}
                variant="outlined"
                onClick={() => {
                  setEditingField('lastName');
                  setOpenNameDialog(true);
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F9F9F9',
                    borderRadius: '14px',
                    height: '52px',
                    cursor: 'pointer',
                    fontFamily: 'Jost, sans-serif',
                    '& fieldset': {
                      borderColor: 'rgba(121,121,121,0.3)',
                    },
                    '&:hover fieldset': {
                      borderColor: 'rgba(121,121,121,0.5)',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: environment.mainColor,
                    },
                  },
                  '& .MuiInputBase-input': {
                    cursor: 'pointer',
                    fontFamily: 'Jost, sans-serif',
                  },
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <EditIcon style={{ color: environment.mainColor }} />
                  ),
                }}
              />
            </Grid>
          </Grid>

          {/* Email and Phone Number Row */}
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{
                  fontWeight: 'bold',
                  marginBottom: '8px',
                  fontSize: '16px',
                  fontFamily: 'Jost, sans-serif',
                  color: '#333',
                }}
              >
                Email
              </Typography>
              <TextField
                fullWidth
                value={email || user?.email || ''}
                placeholder="Enter Mail ID"
                variant="outlined"
                onClick={() => setOpenEmailDialog(true)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F9F9F9',
                    borderRadius: '14px',
                    height: '52px',
                    cursor: 'pointer',
                    fontFamily: 'Jost, sans-serif',
                    '& fieldset': {
                      borderColor: 'rgba(121,121,121,0.3)',
                    },
                    '&:hover fieldset': {
                      borderColor: 'rgba(121,121,121,0.5)',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: environment.mainColor,
                    },
                  },
                  '& .MuiInputBase-input': {
                    cursor: 'pointer',
                    fontFamily: 'Jost, sans-serif',
                  },
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <EditIcon style={{ color: environment.mainColor }} />
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography
                sx={{
                  fontWeight: 'bold',
                  marginBottom: '8px',
                  fontSize: '16px',
                  fontFamily: 'Jost, sans-serif',
                  color: '#333',
                }}
              >
                Phone Number
              </Typography>
              <TextField
                fullWidth
                value={user?.phoneNumber || ''}
                placeholder="Enter Phone Number"
                variant="outlined"
                onClick={() => setOpenPhoneDialog(true)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#F9F9F9',
                    borderRadius: '14px',
                    height: '52px',
                    cursor: 'pointer',
                    fontFamily: 'Jost, sans-serif',
                    '& fieldset': {
                      borderColor: 'rgba(121,121,121,0.3)',
                    },
                    '&:hover fieldset': {
                      borderColor: 'rgba(121,121,121,0.5)',
                    },
                    '&.Mui-focused fieldset': {
                      borderColor: environment.mainColor,
                    },
                  },
                  '& .MuiInputBase-input': {
                    cursor: 'pointer',
                    fontFamily: 'Jost, sans-serif',
                    direction: 'initial',
                  },
                }}
                InputProps={{
                  readOnly: true,
                  endAdornment: (
                    <EditIcon style={{ color: environment.mainColor }} />
                  ),
                }}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Dialog Components */}
        {user && (
          <ChangeEmail
            onClose={() => setOpenEmailDialog(false)}
            open={openEmailDialog}
            setEmail={setEmail}
            user={user}
            email={email}
          />
        )}
        {user && (
          <PhoneNumberForm
            onClose={() => setOpenPhoneDialog(false)}
            open={openPhoneDialog}
            phoneNumber={phoneNumber}
            setPhoneNumber={setPhoneNumber}
            user={user}
          />
        )}
        {user && (
          <ChangeName
            user={user}
            setName={setName}
            onClose={() => {
              setOpenNameDialog(false);
              setEditingField(null);
            }}
            open={openNameDialog}
            name={name}
            editingField={editingField}
          />
        )}
      </Container>
    );
  }

  return (
    <Container
      maxWidth="lg"
      style={{ marginTop: '30px', marginBottom: '30px' }}
    >
      <Box
        sx={{
          width: ' 100%',
          maxWidth: '100%',
        }}
      >
        <p style={{ fontWeight: 'bold', marginTop: '5px' }}>
          {t('profilee.name')}
        </p>
        <Grid item xs={12}>
          <div
            style={{
              padding: '11px 14px',
              border: '1px solid rgba(121,121,121,0.5)',
              borderRadius: '14px',
              height: '52px',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              backgroundColor: '#F9F9F9',
            }}
            onClick={() => {
              setEditingField('both');
              setOpenNameDialog(true);
            }}
          >
            <Typography>
              {user?.firstName && user?.lastName
                ? `${user.firstName} ${user.lastName}`
                : user?.fullName || ''}
            </Typography>
            <EditIcon style={{ color: environment.mainColor }} />
          </div>
        </Grid>
      </Box>
      <Box
        sx={{
          width: ' 100%',
          maxWidth: '100%',
          marginTop: '25px',
          marginBottom: '25px',
        }}
      >
        <p style={{ fontWeight: 'bold', marginTop: '5px' }}>
          {t('profilee.phone')}
        </p>
        <Grid item xs={12}>
          <div
            style={{
              padding: '11px 14px',
              border: '1px solid rgba(121,121,121,0.5)',
              borderRadius: '14px',
              height: '52px',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              backgroundColor: '#F9F9F9',
            }}
            onClick={() => setOpenPhoneDialog(true)}
          >
            <Typography style={{ direction: 'initial' }}>
              {' '}
              {user?.phoneNumber}
            </Typography>
            <EditIcon style={{ color: environment.mainColor }} />
          </div>
        </Grid>
      </Box>
      <Box
        sx={{
          width: ' 100%',
          maxWidth: '100%',
        }}
      >
        <p style={{ fontWeight: 'bold', marginTop: '5px' }}>
          {t('profilee.email')}
        </p>
        <Grid item xs={12}>
          <div
            style={{
              padding: '11px 14px',
              border: '1px solid rgba(121,121,121,0.5)',
              borderRadius: '14px',
              height: '52px',
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'space-between',
              backgroundColor: '#F9F9F9',
            }}
            onClick={() => setOpenEmailDialog(true)}
          >
            <Typography>{email ? email : user?.email}</Typography>
            <EditIcon style={{ color: environment.mainColor }} />
          </div>
        </Grid>
      </Box>
      {user && (
        <ChangeEmail
          onClose={() => setOpenEmailDialog(false)}
          open={openEmailDialog}
          setEmail={setEmail}
          user={user}
          email={email}
        />
      )}
      {user && (
        <PhoneNumberForm
          onClose={() => setOpenPhoneDialog(false)}
          open={openPhoneDialog}
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          user={user}
        />
      )}
      {user && (
        <ChangeName
          user={user}
          setName={setName}
          onClose={() => setOpenNameDialog(false)}
          open={openNameDialog}
          name={name}
        />
      )}
    </Container>
  );
};

export default PersonalInfo;
